// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PutGoodsInBox_pageWrapper__OfDLD","pageImage":"PutGoodsInBox_pageImage__kmUVw"};